const isLoggedIn = state => !!state.user.token
const isLoading = state => state.loading
const user = state => state.user
const token = state => state.user.token

export default {
  isLoggedIn,
  isLoading,
  user,
  token
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js